import { PaymentApi, PaymentResult } from '../../infrastructure/api';
import { PaymentSaleRequest } from '../../shared/types';
import { SaleTransaction } from '../../domain/entities';

export class ProcessSaleUseCase {
    async execute(
        saleTransaction: SaleTransaction,
        cnpj: string,
        token: string
    ): Promise<PaymentResult> {
        if (!saleTransaction.isValid) {
            throw new Error('Dados da venda inválidos');
        }

        const requestData = this.buildPaymentRequest(saleTransaction, cnpj);
        return await PaymentApi.processSale(requestData, token);
    }

    private buildPaymentRequest(
        saleTransaction: SaleTransaction,
        cnpj: string
    ): PaymentSaleRequest {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const hour = `${hours}${minutes}${seconds}`;

        const year = String(now.getFullYear());
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const date = `${year}${month}${day}`;

        const totalValueInCents = Math.round(
            parseFloat(saleTransaction.totalValue.replace(',', '.')) * 100
        );
        const litersWithoutDecimals = Math.round(
            parseFloat(saleTransaction.liters.replace(',', '.')) * 100
        );
        const cardNumber = saleTransaction.vehicle?.card.replace(/\s/g, '') || '';
        const cleanCNPJ = cnpj.replace(/\D/g, '');
        const productId = saleTransaction.product?.id
            ? String(saleTransaction.product.id).padStart(3, '0')
            : '001';

        return {
            BIT_03: '5030',
            BIT_04: String(totalValueInCents),
            BIT_07: '',
            BIT_11: '',
            BIT_12: hour,
            BIT_13: date,
            BIT_35: cardNumber,
            BIT_37: '',
            BIT_42: cleanCNPJ,
            BIT_47_PA: '',
            BIT_47_PR: productId,
            BIT_47_Q: String(litersWithoutDecimals),
            BIT_47_H: saleTransaction.odometer || '1',
            BIT_47_M: saleTransaction.driver?.registration || '',
            BIT_47_CVC: '',
            BIT_52: saleTransaction.password || '',
        };
    }
}

